import { createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-056f8aa9"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info" }, [
  /*#__PURE__*/_createElementVNode("div", null, " A new image/PDF will be generated for each value of the selected filter. The following restrictions apply: "),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, "Only Categorical filters are supported that are not in exclude mode"),
    /*#__PURE__*/_createElementVNode("li", null, " Some filters may be missing from the autocomplete dropdown. The filter name & value may be entered as free text ")
  ])
], -1 /* HOISTED */))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sep" }, null, -1 /* HOISTED */))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sep" }, null, -1 /* HOISTED */))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sep" }, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["TableauPopup"], {
    ref: "popup",
    width: 300,
    title: "Configure an iteration filter",
    submitText: "Set Filter",
    status: $setup.status,
    statusMessage: $setup.submitInfo.text,
    canSubmit: $setup.submitInfo.canSubmit,
    statusLink: $setup.actionLink,
    onSubmitted: $setup.set
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode($setup["TableauSimpleAutocomplete"], {
        label: "Filter Name:",
        modelValue: $setup.filterName,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.filterName) = $event)),
        getAutocompleteItems: () => $props.allPossibleFilterNames,
        placeholder: "Name of the filter to apply"
      }, null, 8 /* PROPS */, ["modelValue", "getAutocompleteItems"]),
      _hoisted_2,
      _createVNode($setup["TableauRichTextBox"], {
        modelValue: $setup.filterValueText,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.filterValueText) = $event)),
        label: "Values",
        placeholder: "Enter the filter values. One per line.",
        rows: 10
      }, null, 8 /* PROPS */, ["modelValue"]),
      _hoisted_3,
      _hoisted_4
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["status", "statusMessage", "canSubmit", "statusLink"]))
}